class AddToExistingModel {
    constructor({ orders = null, location = null, driverName = null, driverId = null,driverEmail=null } = {}) {
        this.orders = orders;
        this.location = location ? new Location(location) : null;
        this.driverName = driverName;
        this.driverId = driverId;
        this.driverEmail = driverEmail;
    }

    static fromJson(json) {
        return new AddToExistingModel({
            orders: Array.isArray(json.orders) ? json.orders.map(String) : null,
            location: json.location ? Location.fromJson(json.location) : null,
            driverName: json.driver_name || null,
            driverId: json.driver_id || null,
            driverEmail: json.driver_email || null,
        });
    }

    toJson() {
        return {
            orders: this.orders,
            location: this.location ? this.location.toJson() : null,
            driver_name: this.driverName,
            driver_id: this.driverId,
            driver_email: this.driverEmail,
        };
    }
}


class Location {
    constructor({
                    type = null,
                    vendorName = null,
                    vendorId = null,
                    email = null,
                    id = null,
                    name = null,
                    address = null,
                    country = null,
                    countryId = null,
                    city = null,
                    cityId = null,
                    area = null,
                    lat = null,
                    lng = null,
                    pickupTime = null,
                    landmark = null,
                    phoneCode = null,
                    phoneNumber = null,
                    originHubId = null,
                    originHub = null,
                    returnHubId = null,
                    returnHub = null,
                    returnInfoName = null,
                } = {}) {
        this.type = type;
        this.vendorName = vendorName;
        this.vendorId = vendorId;
        this.email = email;
        this.id = id;
        this.name = name;
        this.address = address;
        this.country = country;
        this.countryId = countryId;
        this.city = city;
        this.cityId = cityId;
        this.area = area;
        this.lat = lat;
        this.lng = lng;
        this.pickupTime = pickupTime;
        this.landmark = landmark;
        this.phoneCode = phoneCode;
        this.phoneNumber = phoneNumber;
        this.originHubId = originHubId;
        this.originHub = originHub;
        this.returnHubId = returnHubId;
        this.returnHub = returnHub;
        this.returnInfoName = returnInfoName;
    }

    static fromJson(json) {
        return new Location({
            type: json.type || null,
            vendorName: json.vendor_name || null,
            vendorId: json.vendor_id || null,
            email: json.email || null,
            id: json.id || null,
            name: json.name || null,
            address: json.address || null,
            country: json.country || null,
            countryId: json.country_id || null,
            city: json.city || null,
            cityId: json.city_id || null,
            area: json.area || null,
            lat: json.lat || null,
            lng: json.lng || null,
            pickupTime: json.pickup_time || null,
            landmark: json.landmark || null,
            phoneCode: json.phone_code || null,
            phoneNumber: json.phone_number || null,
            originHubId: json.origin_hub_id || null,
            originHub: json.origin_hub || null,
            returnHubId: json.return_hub_id || null,
            returnHub: json.return_hub || null,
            returnInfoName: json.return_info_name || null,
        });
    }

    toJson() {
        return {
            type: this.type,
            vendor_name: this.vendorName,
            vendor_id: this.vendorId,
            email: this.email,
            id: this.id,
            name: this.name,
            address: this.address,
            country: this.country,
            country_id: this.countryId,
            city: this.city,
            city_id: this.cityId,
            area: this.area,
            lat: this.lat,
            lng: this.lng,
            pickup_time: this.pickupTime,
            landmark: this.landmark,
            phone_code: this.phoneCode,
            phone_number: this.phoneNumber,
            origin_hub_id: this.originHubId,
            origin_hub: this.originHub,
            return_hub_id: this.returnHubId,
            return_hub: this.returnHub,
            return_info_name: this.returnInfoName,
        };
    }
}

export { AddToExistingModel, Location };
